import React from "react";
import { Check } from "lucide-react";
import { about } from "../data/mock";

const About = () => {
  return (
    <section id="about" className="section bg-[#F8F5EE]">
      <div className="max-w-7xl mx-auto container-px grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5 reveal">
          <span className="eyebrow">About</span>
          <h2 className="h-section text-3xl lg:text-5xl mt-6">
            A rare blend of clinical, administrative & legal expertise.
          </h2>
          <div className="divider-gold" />
          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {about.highlights.map((h, i) => (
              <div key={i} className="flex items-start gap-3">
                <span className="mt-1 inline-flex w-5 h-5 items-center justify-center bg-[#0B1E3F] text-[#C9A961]">
                  <Check size={12} strokeWidth={3} />
                </span>
                <span className="text-sm text-[#0B1E3F]/85">{h}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="lg:col-span-7 reveal">
          <div className="space-y-6">
            {about.paragraphs.map((p, i) => (
              <p
                key={i}
                className={`leading-[1.85] ${
                  i === 0
                    ? "text-[18px] lg:text-[20px] text-[#0B1E3F] font-serif"
                    : "text-[15px] text-[#0B1E3F]/80"
                }`}
              >
                {p}
              </p>
            ))}
          </div>

          <div className="mt-10 grid grid-cols-3 gap-px bg-[#0B1E3F]/10 border border-[#0B1E3F]/10">
            <div className="bg-[#F8F5EE] p-6">
              <div className="text-[11px] tracking-[0.2em] uppercase text-[#0B1E3F]/60">Established</div>
              <div className="font-serif text-3xl mt-2">2018</div>
            </div>
            <div className="bg-[#F8F5EE] p-6">
              <div className="text-[11px] tracking-[0.2em] uppercase text-[#0B1E3F]/60">Based</div>
              <div className="font-serif text-2xl mt-2">Ahmedabad</div>
            </div>
            <div className="bg-[#F8F5EE] p-6">
              <div className="text-[11px] tracking-[0.2em] uppercase text-[#0B1E3F]/60">Reach</div>
              <div className="font-serif text-2xl mt-2">Pan-Gujarat</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
